export const SDK_ERRORS_TO_IGNORE = [
  "popup_closed_by_user",
  "user_cancelled_authorize"
];
